var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { InvisibleTestElement, StatusIconType, StatusLine } from '../../../shared';
import { ScheduledShiftStatusType, useWorkedShiftStatus, WorkedShiftStatusType } from '../../../../hooks';
import { ShiftCardWorkedStatus } from '.';
import { gql } from '@apollo/client';
import { TimeOffEntryStatus } from '@amzn/atoz-shiftapp-types';
import { DateTime } from 'luxon';
import { formatDuration, getTimeIntervalStr, useAssociateContext } from '@amzn/atoz-shiftapp-utilities';
import { useTranslation } from 'react-i18next';
export var ShiftCardWorkedStatusFeature = function (_a) {
    var _b;
    var scheduleShift = _a.scheduleShift, timeoffEntries = _a.timeoffEntries;
    var t = useTranslation().t;
    var pantherVtoDisabled = useAssociateContext().features.pantherVtoDisabled;
    var shiftStatusMap = useWorkedShiftStatus({
        scheduleShift: scheduleShift,
        timeoffEntries: timeoffEntries
    });
    var statusToRender = [];
    if (shiftStatusMap[ScheduledShiftStatusType.hasTimeOff]) {
        timeoffEntries.map(function (timeOffEntry, i) {
            var intervalStr = getTimeIntervalStr(DateTime.fromISO(timeOffEntry.startAt), DateTime.fromISO(timeOffEntry.endAt));
            var isPending = timeOffEntry.status === TimeOffEntryStatus.Pending;
            statusToRender.push(React.createElement(StatusLine, { key: "".concat(ScheduledShiftStatusType.hasTimeOff, "_").concat(i), dataTestId: "ShiftCardWorkedStatus_hasTimeOff_".concat(isPending ? 'pending' : 'approved', "_").concat(i), text: t(isPending
                    ? 'shift_management_features_ShiftCard_timeOffPending'
                    : 'shift_management_features_ShiftCard_timeOffApproved', { intervalStr: intervalStr }), statusIcon: {
                    iconType: isPending
                        ? StatusIconType.IconInformationFill
                        : StatusIconType.IconCheckCircleFill,
                    color: isPending ? 'neutral50' : 'green70'
                } }));
        });
    }
    if (shiftStatusMap[WorkedShiftStatusType.vtoAccepted] &&
        !pantherVtoDisabled) {
        (_b = scheduleShift.acceptedVtoTimeRanges) === null || _b === void 0 ? void 0 : _b.map(function (vtoTimeRange, i) {
            var intervalStr = getTimeIntervalStr(DateTime.fromISO(vtoTimeRange.start), DateTime.fromISO(vtoTimeRange.end));
            var duration = DateTime.fromISO(vtoTimeRange.end).diff(DateTime.fromISO(vtoTimeRange.start), ['hours', 'minutes', 'seconds']);
            var durationStr = formatDuration(duration);
            statusToRender.push(React.createElement(StatusLine, { dataTestId: "ShiftCardWorkedStatus_VtoAccepted_".concat(i), key: "".concat(WorkedShiftStatusType.vtoAccepted, "_").concat(i), text: t('shift_management_features_ShiftCard_vtoAccepted', {
                    intervalStr: intervalStr,
                    durationStr: durationStr
                }), statusIcon: {
                    iconType: StatusIconType.IconCheckCircleFill,
                    color: 'green70'
                } }));
        });
    }
    if (shiftStatusMap[WorkedShiftStatusType.none]) {
        statusToRender.push(React.createElement(InvisibleTestElement, { dataTestId: "ShiftCardWorkedStatus_Empty", key: WorkedShiftStatusType.none }));
    }
    return React.createElement(ShiftCardWorkedStatus, null, statusToRender);
};
ShiftCardWorkedStatusFeature.fragments = {
    scheduleShift: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment ShiftCardWorkedStatus_ScheduleShift on ScheduleShift {\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n            ...UseWorkedShiftStatus_ScheduleShift\n        }\n\n        ", "\n    "], ["\n        fragment ShiftCardWorkedStatus_ScheduleShift on ScheduleShift {\n            acceptedVtoTimeRanges {\n                start\n                end\n            }\n            ...UseWorkedShiftStatus_ScheduleShift\n        }\n\n        ", "\n    "])), useWorkedShiftStatus.fragments.scheduleShift)
};
var templateObject_1;
